// extracted by mini-css-extract-plugin
export var configurationReminder = "styles-module--configurationReminder--006c8";
export var configurationReminderWrapper = "styles-module--configurationReminderWrapper--f3fd8";
export var customWrapper = "styles-module--customWrapper--ed920";
export var productImageCarousel = "styles-module--productImageCarousel--49d5a";